import { createHelpers } from 'vuex-map-fields'

const { getDocuments, setDocuments } = createHelpers({
  getterType: 'getDocuments',
  mutationType: 'setDocuments',
})

export default {
  namespaced: true,
  state: {
    documentList: undefined,

    // TODO: refactor this filterActive and sortActive
    filterActive: false,
    filter: [
      {
        key: 'name',
        operator: 'IS',
        value: [''],
      },
    ],
    sortActive: false,
    sort: [],
    search: '',
    treeSearch: '',
    documentOptions: [
      {
        field: 'filter_search_children',
        label: 'Cari/Filter Sub-Dokumen',
        value: false,
      },
    ],
  },
  getters: {
    getDocuments,
  },
  mutations: {
    setDocuments,
  },
  actions: {
    updateDocumentList(state, payload) {
      console.log(payload)

      state.commit('setDocuments', { path: 'documentList', value: payload })
    },

    resetSort(state) {
      state.state.sort = []
    },
    toggleSort(state, toggleState) {
      state.state.sortActive = toggleState
    },
    resetFilter(state) {
      state.state.filter = [
        {
          key: 'name',
          operator: 'IS',
          value: [''],
        },
      ]
    },
    toggleFilter(state, toggleState) {
      state.state.filterActive = toggleState
    },
  },
}
